import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanLoad, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../../services/storage.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuardSessao implements CanActivate, CanLoad {

  constructor(
    protected storage: StorageService,
    protected route: Router) { }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (this.storage.getLocalUser() && sessionStorage.getItem('timeOut') != 'ativa') {
      return true;
    } else {
    //  this.route.navigate(['/login']);
    // alert("Acesso não permitodo a sua sessão ainda estar ativa")
      return false;
    }
  }

  canLoad(route: Route): boolean | Observable<boolean> | Promise<boolean> {
    if (this.storage.getLocalUser()) {
      return true;
    } else {
      // this.route.navigate(['/login']);
      return false;
    }
  }

}
